/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { useSelector } from "react-redux";

import { PageContainer } from "../components/layout/PageContainer";
import { selectName } from "../features/azure-b2c/storage";
import { usePermission } from "../hooks/usePermission";
import { DashboardPromotionsAtomic } from "../services/atomic/DashboardPromotionsAtomic";
import { TestIds } from "../testIds";

const Home = () => {
  const username = useSelector(selectName);

  const canViewShop = usePermission("FarmlandsProShop_ShopView").allowed;

  return (
    <PageContainer data-testid={TestIds.pages.home}>
      <h1>Kia Ora {username}</h1>
      <DashboardPromotionsAtomic />
    </PageContainer>
  );
};

export default Home;
